// @flow 

import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../reduxStore/modules/user/actions';
import { log } from '../utils/jsUtils';

const Logout = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  
  // Perform logout when component mounts
  useEffect(() => {
    const performLogout = async () => {
      log('[Logout] Logging out user');
      try {
        await dispatch(logout());
        log('[Logout] Logout successful, redirecting to home');
        history.push('/');
      } catch (error) {
        log('[Logout] Error during logout:', error);
        history.push('/');
      }
    };
    
    performLogout();
  }, [dispatch, history]);
  
  // Show nothing while logging out
  return null;
};

export default Logout;